import { BillingAmountUpdateResultDto } from '../../billing-amount-update/dto/billing-amount-update-result.dto';
import { BillingAmountUpdateDto } from '../../billing-amount-update/dto/billing-amount-update.dto';
import { PagedResultGeneric } from '../../../shared/model/paged-result.model';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../shared/api/api.service';
import { UtilService } from '../../../shared/util/util.service';
import { PagedResult } from '../../../shared/model/generic-paged-result.model';

import { IBillingService } from './ibilling.service';
import { Billing } from './billing.model';
import { BillingCycle } from './billing-cycle.model';
import { BillingSearchDto } from './dto/billing-search.dto';
import { BillingDto } from './dto/billing.dto';
import { BillingSearch } from './billing-search.model';
import { BillingAmountUpdatePreviewDto } from '../../billing-amount-update/dto/billing-amount-update-preview.dto';

@Injectable()
export class BillingService implements IBillingService {
  public _apiService: ApiService;
  public _utilService: UtilService;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  createBilling(billing: Billing): Promise<number> {
    return this._apiService.post(`Billing`, billing);
  }

  updateBilling(billing: Billing): Promise<void> {
    return this._apiService.put(`Billing`, billing);
  }

  deleteBilling(billingId: number): Promise<void> {
    return this._apiService.delete(`Billing/${billingId}`);
  }

  getBillingCycles(): Promise<Array<BillingCycle>> {
    return this._apiService.get(`BillingCycles`);
  }
  getBillingsForProfile(profileId: number): Promise<PagedResultGeneric<BillingDto>> {
    return this._apiService.getPaged('Billings', {
      Inactive: false,
      PageNumber: 0,
      PageSize: 0,
      ProfileIds: profileId,
    });
  }

  searchBillings(params: BillingSearch): Promise<any> {
    return this._apiService.getPaged('Billings', params);
  }

  previewAmountUpdate(params: BillingAmountUpdateDto): Promise<PagedResultGeneric<BillingAmountUpdatePreviewDto>> {
    return this._apiService.post('Billings/AmountUpdate/Preview', params);
  }

  persistBillingAmountUpdates(billings: PagedResultGeneric<BillingAmountUpdatePreviewDto>): Promise<BillingAmountUpdateResultDto> {
    return this._apiService.post('Billings/AmountUpdate', billings.Result);
  }

  getBillingsForPledge(pledgeId: number): Promise<PagedResultGeneric<Billing>> {
    return this._apiService.getPaged('Billings', {
      Inactive: false,
      PageNumber: 0,
      PageSize: 0,
      PledgeId: pledgeId,
    });
  }
}
